import { api } from "./api";
import { Currency } from "../types/currency.type";
import { SalesTariffRule, User } from "../types/user.type";

export interface CreateSalesUserPayload {
  username: string;
  name: string;
  password: string;
  salaryAmount?: number;
  salaryCurrency?: Currency;
  tariffRules?: SalesTariffRule[];
}

export interface UpdateSalesProfilePayload {
  salaryAmount?: number;
  salaryCurrency?: Currency;
  tariffRules: SalesTariffRule[];
}

export interface SalesUserResponse {
  message: string;
  user: User;
}

export const crmApi = {
  async getSalesUsers(): Promise<User[]> {
    const { data } = await api.get<User[]>("/crm/sales-users");
    return data;
  },
  async createSalesUser(
    payload: CreateSalesUserPayload
  ): Promise<SalesUserResponse> {
    const { data } = await api.post<SalesUserResponse>(
      "/crm/sales-users",
      payload
    );
    return data;
  },
  async updateSalesProfile(
    id: string,
    payload: UpdateSalesProfilePayload
  ): Promise<SalesUserResponse> {
    const { data } = await api.put<SalesUserResponse>(
      `/crm/sales-users/${id}/profile`,
      payload
    );
    return data;
  },
  async loginSales(payload: { username: string; password: string }) {
    const { data } = await api.post("/crm/sales/login", payload);
    return data;
  },
  async deleteSalesUser(id: string) {
    const { data } = await api.delete<{ message: string }>(
      `/crm/sales-users/${id}`
    );
    return data;
  },
  async getSalesUserPassword(id: string): Promise<{ password: string; username: string; name: string }> {
    const { data } = await api.get<{ password: string; username: string; name: string }>(
      `/crm/sales-users/${id}/password`
    );
    return data;
  },
};

